import { useFormik } from 'formik';
import { AgButton, AgInput, AgModal, AgModalActions, AgModalContent } from 'src/components/ui';
import { notifyUnlessSurfaced } from 'src/lib/apollo/appErrorLink';
import { notify } from 'src/lib/notify';
import { useCreateCommodity } from './product.api';

export default function AddCommodityModal({ handleClose, openAddCommodity }) {
  const { create, loading } = useCreateCommodity();

  const formik = useFormik({
    initialValues: { name: '' },
    validateOnChange: false,
    onSubmit: async (input, helpers) => {
      try {
        const { data } = await create(input);

        if (!data?.createCommodity?.id) {
          throw new Error('The server did not return the new commodity.');
        }

        helpers.resetForm();
        handleClose();
        notify.success('New commodity added');
      } catch (error) {
        console.error('Error creating commodity:', error);
        notifyUnlessSurfaced(error, 'Failed to create commodity.');
      }
    },
  });

  const values = formik.values;

  const handleCloseWithReset = () => {
    formik.resetForm();
    handleClose();
  };

  return (
    <AgModal open={openAddCommodity} onClose={handleCloseWithReset} title="Enter New Commodity Name">
      <form onSubmit={formik.handleSubmit}>
        <AgModalContent>
          <p className="text-sm text-neutral-secondary mb-3">
            After adding this commodity, you can configure it with additional options.
          </p>
          <AgInput
            autoFocus
            label="Name"
            value={values.name}
            onChange={(value) => formik.setFieldValue('name', value)}
            className="pt-3"
          />
        </AgModalContent>
        <AgModalActions>
          <AgButton variant="primary" type="submit" isDisabled={values.name?.length === 0 || loading}>
            Add
          </AgButton>
        </AgModalActions>
      </form>
    </AgModal>
  );
}
